import React from 'react';
import { Menu, Image } from 'semantic-ui-react';
import twIcon from '../../../../assets/images/tw.svg';
import fbIcon from '../../../../assets/images/fb.svg';
import podIcon from '../../../../assets/images/podcast.svg';
import classes from './desktopNav.css';

const NavMenuIconGroup = () => (
  <Menu.Menu position="right">
    <Menu.Item link className={classes.icon}>
      <Image
        src={fbIcon}
        inline
        as="a"
        href="https://www.facebook.com/thehuddle"
        target="_blank"
      />
    </Menu.Item>
    <Menu.Item link className={classes.icon}>
      <Image
        src={twIcon}
        inline
        as="a"
        href="https://www.twitter.com/TheHuddle"
        target="_blank"
      />
    </Menu.Item>
    <Menu.Item link className={classes.icon}>
      <Image
        src={podIcon}
        inline
        as="a"
        href="https://thehuddle.com/category/fantasy-football-player-analysis-tips-advice-picks/fantasy-football-podcast/"
        target="_blank"
      />
    </Menu.Item>
  </Menu.Menu>
);

export default NavMenuIconGroup;



// WEBPACK FOOTER //
// ./src/app/components/Nav/DesktopNav/NavMenuIconGroup.js